<div *ngIf="!singleRoom" class="content-header flex-row">
  <h1>{{'Alarm Logs' | translate}}</h1>
  <div *ngIf="loading" class="loading-indicator"><div></div><div></div><div></div><div></div></div>
</div>

<div class="content-container">
  <div class="flex-row" style="align-items: center;">
    <app-filter
    *ngIf="!singleRoom"
    class="margin-right50"
      [inputDelay]="1500"
      (filteredValue)="searchFilterReady($event)">
    </app-filter>

    <div *ngIf="singleRoom" class="flex-row">
      <select [(ngModel)]="mainController" (ngModelChange)="controllerChanged($event)" >
      <option *ngFor="let controller of controllers" [ngValue]="controller"> {{ controller.name }}</option>
      </select>
    </div>

    <app-date-time-from-to (selectedDateTimeFromTo)="setDateTimeFromTo($event)"></app-date-time-from-to>

    <app-paginator
      *ngIf="alarmLogData.length > 0"
      class="to-right"
      [paginationData]="paginationData"
      (targetPage)="onSubmit($event)">
   </app-paginator>
  </div>

  <div *ngIf="alarmLogData.length === 0 && !loading">{{'No results found' | translate}}.</div>
  <div *ngIf="singleRoom && loading" class="width100 flex-row-center-h"><div class="lds-dual-ring"></div></div>


  <div class="margin-top30" *ngIf="alarmLogData.length > 0">
    <table class="logs-table" >
      <thead>
        <tr>
          <th class="clickable width20" (click)="onSort('TIME')">{{'Timestamp' | translate}}
            {{this.requestBody.sorting==='ASC|TIME'?"▲":""}}
            {{this.requestBody.sorting==='DSC|TIME'?"▼":""}}
          </th>
          <th class="clickable width10" (click)="onSort('LEVEL')">{{'Level' | translate}}
            {{this.requestBody.sorting==='ASC|LEVEL'?"▲":""}}
            {{this.requestBody.sorting==='DSC|LEVEL'?"▼":""}}
          </th>
          <th class="clickable" (click)="onSort('DESCRIPT')">{{'Description' | translate}}
            {{this.requestBody.sorting==='ASC|DESCRIPT'?"▲":""}}
            {{this.requestBody.sorting==='DSC|DESCRIPT'?"▼":""}}
          </th>
          <th>{{'Data' | translate}}</th>
          <th>{{'User confirmed' | translate}}</th>
          <th>{{'Confirmation text' | translate}}</th>
          <th>{{'Confirmation time' | translate}}</th>
          </tr>
      </thead>

      <tr *ngFor="let log of alarmLogData">
        <td class="opacity0-4">{{log.timestamp | date:'dd.MM.yyyy. HH:mm:ss'}}</td>
        <td class="opacity0-4">{{log.level}}</td>
        <td class="opacity0-4">{{log.description}}</td>
        <td class="opacity0-4">{{log.data}}</td>
        <td class="opacity0-4">{{log.confirmUsername}}</td>
        <td class="opacity0-4">{{log.confirmText}}</td>
        <td class="opacity0-4">{{log.confirmTimestamp | date:'dd.MM.yyyy. HH:mm:ss'}}</td>
      </tr>
    </table>

    <app-paginator class="flex-row from-back margin-top20 margin-bottom20"
      [paginationData]="paginationData"
      (targetPage)="onSubmit($event)">
    </app-paginator>
  </div>
</div>


